module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAAAGCAYAAABKDyn0AAAAwUlEQVRIS2NkIAL8L20M/f+fYRURSmmhZDVTT30YuQZXL7oXysA4QG5nZFjdGqOE1e2MhDz0P7dSlIGd48p/BgYxQmqpLc/IwPCK4ecPHcbJ7a/JMbty3m1RJlbmKwwD4HYGBoZX/37/1WlPUsXqdoIB/6+kEZTSQ8nxOKV6GBkZwhi761eTa071knurGP4PjNsZ/jOEtcYp4XQ73oAfLWLIjHI8RQzMRJwBP1rEkBnoBIoYggE/WsSQGfAEihiYqQByuFQHZowVogAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/img-division-location-1.png
// module id = 865
// module chunks = 124